import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";

// SEC-002: fetch protected files with the auth cookie (credentials: 'include')
// and hand the browser a blob: URL that carries no credentials.

const _cache = new Map(); // fileId -> objectUrl (in-memory)

async function fetchAsBlobUrl(fileId) {
  if (!fileId) return null;
  if (_cache.has(fileId)) return _cache.get(fileId);
  // Auth hardening: rely on the httpOnly cookie via credentials: 'include'.
  const res = await fetch(`${API}/files/${fileId}`, { credentials: "include" });
  if (!res.ok) throw new Error(`file ${fileId} status ${res.status}`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  _cache.set(fileId, url);
  return url;
}

export function AuthImage({ fileId, alt = "", className, style, ...rest }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let alive = true;
    setErr(false);
    fetchAsBlobUrl(fileId)
      .then((u) => alive && setUrl(u))
      .catch(() => alive && setErr(true));
    return () => { alive = false; };
  }, [fileId]);
  if (err) {
    return (
      <div
        className={className}
        style={{ ...(style || {}), background: "#F2ECE0", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#4A627A", fontSize: 10 }}
        data-testid="auth-image-error"
      >
        no access
      </div>
    );
  }
  if (!url) {
    return (
      <div
        className={className}
        style={{ ...(style || {}), background: "#F2ECE0" }}
        data-testid="auth-image-loading"
      />
    );
  }
  return <img src={url} alt={alt} className={className} style={style} data-testid="auth-image" {...rest} />;
}

export function AuthAudio({ fileId, className, ...rest }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchAsBlobUrl(fileId)
      .then((u) => alive && setUrl(u))
      .catch(() => {});
    return () => { alive = false; };
  }, [fileId]);
  if (!url) return <div className={className} data-testid="auth-audio-loading" />;
  return <audio src={url} controls className={className} data-testid="auth-audio" {...rest} />;
}
